import {
  first, some, split, startsWith,
} from 'lodash/fp';

const getMessageLocale = ({ locale, preserved } = {}) => (
  some(language => startsWith(language, locale), preserved)
    ? locale : first(split(/[-_]/, locale))
);

export default getMessageLocale;
